<script>
    import Messages from "./helpers/messages/Messages";
    import Auth from "./helpers/Auth";
    import LoadingIcon from "./LoadingIcon.svelte";
    import Footer from "./Footer.svelte";
    import Header from "./Header.svelte";
    import {validateEmail} from "../lib/Common.svelte";
    import {setupI18n, _} from "../lib/i18n";

    export let language = 'en-US';

    setupI18n({ withLocale: language });
    export let auth_endpoint = '/auth/';

    export let isNewDashboard = false;

    export let csrfKey = '_csrf';
    export let csrfValue = null;

    export let enableManualRegistration = true;

    export let ruSpyNoTrialGroup = '';

    export let enableAutoReg = false;

    if (ruSpyNoTrialGroup === 'b') {
        enableManualRegistration = true;
        enableAutoReg = false;
    }

    Messages.registerLanguageVersion(language);

    let email;
    let password;
    let error;

    let mainError = null;
    let emailError = null;
    let emailRed = false;
    let passwordError = null;
    let passwordRed = false;
    let showPass = false;

    let loading = false;

    const auth = new Auth({
        auth_endpoint
    });

    $: email;
    $: password;

    let isLoading = false;
    const signUp = async (event) => {
        event.preventDefault();
        event.stopPropagation();

        emailError = null;
        passwordError = null;

        emailRed = false;
        passwordRed = false;

        if (!validateEmail(email)) {
            emailRed = true;
            if (language === 'ru-RU') emailError = 'Введен не корректный e-mail';
        }
        if (!password || password.length < 6) {
            passwordRed = true;
        }
        if (passwordRed || emailRed) return;

        isLoading = true;

        try {
            const response = await auth.signup(email, password, csrfKey, csrfValue);
            if (response.status === 'ok') {
                window.location.href = `/`;
            }
        } catch (err) {
            console.error(err);
            if (err.response.data.errors) {
                if (err.response.data.errors.password) {
                    passwordRed = true;
                    error = err.response.data.errors.password[0];
                }

                if (err.response.data.errors.mail) {
                    emailRed = true;
                    error = err.response.data.errors.mail[0];
                }
            }
        }
        isLoading = false;
    }

    let submitIsEnabled = false;
    $: submitIsEnabled = email && password && email.length > 6 && password.length > 6;
</script>

<Header />

<section class="canvas">
    <div class="canvas__col">
        <section class="auth-block tail">
            <form class="auth-form" on:submit = {signUp}>
            <h2 class="auth-block__title tail__title">{$_('signUpForm.title')}</h2>
            {#if language === 'ru-RU'}
                <p class="auth-block__text tail__text">{$_('signUpForm.orRegisterViaSocials')}:</p>

                <div class="ulogin-panel">
                    <div class="auth-block__social-wrapper ulogin-buttons-container">
                        {#if language === 'ru-RU'}
                            <div style="border: none !important;"
                                 class="auth-block__social-item ulogin-button-vkontakte"
                                 on:click = {(e) => {window.location.href = "https://oauth.vk.com/authorize?client_id=7281535&redirect_uri=https%3A%2F%2Fauth.zengram.ru%2Foauth%2Fsocial%3Flanguage%3Dru-RU%26network%3Dvkontakte%26redirectUrl%3Dhttps%253A%252F%252Finstashpion.ru%252Fauth%252Flogin&response_type=code&scope=email"}}
                                 role="button" title="VK">
                                <img role="button" title="VKontakte" src="/spy20-lk/icons/auth-page/auth-social/auth-icon_vk.svg" alt="VK" class="auth-block__social-icon" />
                            </div>
                            <div style="border: none !important;"
                                 class="auth-block__social-item ulogin-button-yandex"
                                 on:click = {(e) => {window.location.href = "https://oauth.yandex.ru/authorize?client_id=959c782dc2f94ea6a659dfaf6c0ba956&redirect_uri=https%3A%2F%2Fauth.zengram.ru%2Foauth%2Fsocial%3Flanguage%3Dru-RU%26network%3Dyandex%26redirectUrl%3Dhttps%253A%252F%252Finstashpion.ru%252Fauth%252Flogin&response_type=code"}}
                                 role="button" title="Yandex">
                                <img role="button" title="Yandex" src="/spy20-lk/icons/auth-page/auth-social/auth-icon_yandex.svg" alt="Yandex" class="auth-block__social-icon" />
                            </div>
                            <div style="border: none !important;"
                                 class="auth-block__social-item ulogin-button-mailru"
                                 on:click = {(e) => {window.location.href = "https://connect.mail.ru/oauth/authorize?client_id=768740&response_type=code&redirect_uri=https%3A%2F%2Fauth.zengram.ru%2Foauth%2Fsocial%3Flanguage%3Dru-RU%26network%3Dmailru%26redirectUrl%3Dhttps%253A%252F%252Finstashpion.ru%252Fauth%252Flogin"}}
                                 role="button" title="Mail.ru">
                                <img role="button" title="Mail.ru" src="/spy20-lk/icons/auth-page/auth-social/auth-icon_mailru.svg" alt="Mail.ru" class="auth-block__social-icon" />
                            </div>
                            <div style="border: none !important;"
                                 class="auth-block__social-item ulogin-button-odnoklassniki"
                                 on:click = {(e) => {window.location.href = "https://connect.ok.ru/oauth/authorize?client_id=512000333191&redirect_uri=https%3A%2F%2Fauth.zengram.ru%2Foauth%2Fsocial%3Flanguage%3Dru-RU%26network%3Dodnoklassniki%26redirectUrl%3Dhttps%3A%2F%2Finstashpion.ru%2Fauth%2Flogin&response_type=code&scope=GET_EMAIL"}}
                                 role="button" title="Odnoklassniki">
                                <img role="button" title="Одноклассники" src="/spy20-lk/icons/auth-page/auth-social/auth-icon_odnoklassniki.svg" alt="OK" class="auth-block__social-icon" />
                            </div>
                        {:else if language === 'en-US'}
                            <div style="border: none !important;"
                                 class="auth-block__social-item ulogin-button-google"
                                 on:click = {(e) => {window.location.href = "https://accounts.google.com/o/oauth2/v2/auth?response_type=code&access_type=online&client_id=161432133356-03569850460t9lbuemr6airq34vetv27.apps.googleusercontent.com&redirect_uri=https%3A%2F%2Fdatajam.pro%2Finstashpion%2Fgoogle-auth&state&scope=email&approval_prompt=auto"}}
                                 role="button" title="Google">
                                <img role="button" title="Google" src="/spy20-lk/icons/auth-page/auth-social/auth-icon_google.svg" alt="Google" class="auth-block__social-icon" />
                            </div>
                        {/if}
                    </div>
                </div>
            {/if}
            <p class="auth-block__text tail__text">{$_('signUpForm.description')}</p>
            <div class="auth-block__form-wrapper form">
                <input type="email" class={`${emailRed ? 'error' : ''} general-input auth-block__input`} placeholder={$_('signUpForm.emailInputPlaceholder')} bind:value={email} />
                <div class="relative_block">
                    {#if showPass}
                        <input type="text" class={`${passwordRed ? 'error' : ''}
                                general-input auth-block__input`} placeholder={$_('signUpForm.passwordInputPlaceholder')}
                               bind:value={password}/>
                    {:else}
                        <input type="password" class={`${passwordRed ? 'error' : ''}
                                general-input auth-block__input`} placeholder={$_('signUpForm.passwordInputPlaceholder')}
                               bind:value={password}/>
                    {/if}
                    <span on:click={() => {showPass = !showPass}} class="eye_pass">
                        {#if showPass}
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M3 3L15 15" stroke="black" stroke-width="2" stroke-linecap="round" />
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M4.45176 4.36597C3.07891 5.27491 1.99401 6.58339 1.36262 8.12501C1.13303 8.68559 1.13303 9.31441 1.36262 9.87499C2.59358 12.8806 5.54839 15 9 15C10.7255 15 12.3269 14.4703 13.6508 13.565L12.5673 12.4815C11.532 13.1271 10.3094 13.5 9 13.5C6.1781 13.5 3.75892 11.7682 2.75071 9.30648C2.67033 9.11022 2.67033 8.88978 2.75071 8.69352C3.30705 7.33514 4.29303 6.19899 5.53922 5.45344L4.45176 4.36597ZM6.922 6.83622C6.35371 7.38212 6 8.14975 6 9C6 10.6569 7.34315 12 9 12C9.85025 12 10.6179 11.6463 11.1638 11.078L10.1027 10.0169C9.82862 10.314 9.43604 10.5 9 10.5C8.17157 10.5 7.5 9.82843 7.5 9C7.5 8.56396 7.68605 8.17138 7.9831 7.89731L6.922 6.83622ZM11.9988 9.08462L8.91538 6.00117C8.94349 6.00039 8.9717 6 9 6C10.6569 6 12 7.34315 12 9C12 9.0283 11.9996 9.05651 11.9988 9.08462ZM14.0937 11.1795C14.5746 10.6269 14.9672 9.99527 15.2493 9.30648C15.3297 9.11022 15.3297 8.88978 15.2493 8.69352C14.2411 6.23185 11.8219 4.5 9 4.5C8.50822 4.5 8.02868 4.5526 7.5667 4.65249L6.34928 3.43507C7.18113 3.153 8.07263 3 9 3C12.4516 3 15.4064 5.11944 16.6374 8.12502C16.867 8.6856 16.867 9.31441 16.6374 9.87499C16.2794 10.7491 15.7756 11.5482 15.1562 12.242L14.0937 11.1795Z" fill="black" />
                            </svg>
                        {:else}
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M2.05667 9.59073L1.36262 9.87499L2.05667 9.59073ZM2.75072 8.69352C3.75892 6.23184 6.1781 4.5 9 4.5V3C5.54839 3 2.59359 5.11944 1.36262 8.12501L2.75072 8.69352ZM9 4.5C11.8219 4.5 14.2411 6.23185 15.2493 8.69352L16.6374 8.12502C15.4064 5.11944 12.4516 3 9 3V4.5ZM15.2493 9.30648C14.2411 11.7682 11.8219 13.5 9 13.5V15C12.4516 15 15.4064 12.8806 16.6374 9.87499L15.2493 9.30648ZM9 13.5C6.1781 13.5 3.75892 11.7682 2.75071 9.30648L1.36262 9.87499C2.59358 12.8806 5.54839 15 9 15V13.5ZM15.2493 8.69352C15.3297 8.88978 15.3297 9.11022 15.2493 9.30648L16.6374 9.87499C16.867 9.31441 16.867 8.6856 16.6374 8.12502L15.2493 8.69352ZM1.36262 8.12501C1.13303 8.68559 1.13303 9.31441 1.36262 9.87499L2.75071 9.30648C2.67033 9.11022 2.67033 8.88978 2.75072 8.69352L1.36262 8.12501Z"
                                      fill="black"/>
                                <circle cx="9" cy="9" r="2.25" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        {/if}
                    </span>
                </div>
                <button type="submit" class="button button_shadow auth-block__btn" disabled={isLoading || !email || !password || email.length < 6 || password.length < 6}>
                    <LoadingIcon show={isLoading} width="16" height="16" />
                    {$_('signUpForm.registerBtnLabel')}
                </button>

                {#if error}
                    <p class="auth-block__form-error tail__error">{error}</p>
                {/if}
            </div>
            {#if language === 'en-US'}
            <p class="auth-block__text tail__text">{$_('signUpForm.orRegisterViaSocials')}:</p>

            <div class="ulogin-panel">
                <div class="auth-block__social-wrapper ulogin-buttons-container">
                    {#if language === 'ru-RU'}
                    <div style="border: none !important;"
                         class="auth-block__social-item ulogin-button-vkontakte"
                         on:click = {(e) => {window.location.href = "https://oauth.vk.com/authorize?client_id=7281535&redirect_uri=https%3A%2F%2Fauth.zengram.ru%2Foauth%2Fsocial%3Flanguage%3Dru-RU%26network%3Dvkontakte%26redirectUrl%3Dhttps%253A%252F%252Finstashpion.ru%252Fauth%252Flogin&response_type=code&scope=email"}}
                         role="button" title="VK">
                        <img role="button" title="VKontakte" src="/spy20-lk/icons/auth-page/auth-social/auth-icon_vk.svg" alt="VK" class="auth-block__social-icon" />
                    </div>
                        <div style="border: none !important;"
                             class="auth-block__social-item ulogin-button-yandex"
                             on:click = {(e) => {window.location.href = "https://oauth.yandex.ru/authorize?client_id=959c782dc2f94ea6a659dfaf6c0ba956&redirect_uri=https%3A%2F%2Fauth.zengram.ru%2Foauth%2Fsocial%3Flanguage%3Dru-RU%26network%3Dyandex%26redirectUrl%3Dhttps%253A%252F%252Finstashpion.ru%252Fauth%252Flogin&response_type=code"}}
                             role="button" title="Yandex">
                            <img role="button" title="Yandex" src="/spy20-lk/icons/auth-page/auth-social/auth-icon_yandex.svg" alt="Yandex" class="auth-block__social-icon" />
                        </div>
                    <div style="border: none !important;"
                         class="auth-block__social-item ulogin-button-mailru"
                         on:click = {(e) => {window.location.href = "https://connect.mail.ru/oauth/authorize?client_id=768740&response_type=code&redirect_uri=https%3A%2F%2Fauth.zengram.ru%2Foauth%2Fsocial%3Flanguage%3Dru-RU%26network%3Dmailru%26redirectUrl%3Dhttps%253A%252F%252Finstashpion.ru%252Fauth%252Flogin"}}
                         role="button" title="Mail.ru">
                        <img role="button" title="Mail.ru" src="/spy20-lk/icons/auth-page/auth-social/auth-icon_mailru.svg" alt="Mail.ru" class="auth-block__social-icon" />
                    </div>
                    <div style="border: none !important;"
                         class="auth-block__social-item ulogin-button-odnoklassniki"
                         on:click = {(e) => {window.location.href = "https://connect.ok.ru/oauth/authorize?client_id=512000333191&redirect_uri=https%3A%2F%2Fauth.zengram.ru%2Foauth%2Fsocial%3Flanguage%3Dru-RU%26network%3Dodnoklassniki%26redirectUrl%3Dhttps%3A%2F%2Finstashpion.ru%2Fauth%2Flogin&response_type=code&scope=GET_EMAIL"}}
                         role="button" title="Odnoklassniki">
                        <img role="button" title="Одноклассники" src="/spy20-lk/icons/auth-page/auth-social/auth-icon_odnoklassniki.svg" alt="OK" class="auth-block__social-icon" />
                    </div>
                    {:else if language === 'en-US'}
                        <div style="border: none !important;"
                             class="auth-block__social-item ulogin-button-google"
                             on:click = {(e) => {window.location.href = "https://accounts.google.com/o/oauth2/v2/auth?response_type=code&access_type=online&client_id=161432133356-03569850460t9lbuemr6airq34vetv27.apps.googleusercontent.com&redirect_uri=https%3A%2F%2Fdatajam.pro%2Finstashpion%2Fgoogle-auth&state&scope=email&approval_prompt=auto"}}
                             role="button" title="Google">
                            <img role="button" title="Google" src="/spy20-lk/icons/auth-page/auth-social/auth-icon_google.svg" alt="Google" class="auth-block__social-icon" />
                        </div>
                    {/if}
                </div>
            </div>
            {/if}
            </form>
        </section>

        <section class="auth-register-block">
            <h3 class="auth-register-block__title">{$_('signUpForm.alreadyRegisteredLabel')}</h3>
            <a href="/auth/instashpion-login" class="button button_ghost auth-register-block__btn" >
                {$_('signUpForm.signInBtnLabel')}
            </a>
        </section>
    </div>

</section>

<Footer {language} />


<style lang="scss">
  @import "style";

  .auth-form {
    border-bottom: none;
  }

  button[type="submit"] {
    display: flex;
    justify-content: center;
  }

  .auth-block__social-item::before {
    content: '' !important;
  }

  .logo {
    &.ru-RU {
      background: url(https://auth.zengram.ru/themes/spy/logo.png) no-repeat center;
      width: 260px;
    }

    &.en-US {
      background: url(https://auth.datajam.pro/themes/spy/datajam-black-logo.png) no-repeat center;
      background-size: 100%;
      width: 170px;
    }
  }
  .canvas__col {
    width: 350px;
  }
  .relative_block {
    position: relative;
    & input {
      width: 100%;
      margin: 0 0 16px !important;
    }
  }
  .eye_pass {
    position: absolute;
    right: 10px;
    top: 0;
    display: flex;
    align-items: center;
    height: 100%;
  }
</style>